import { MultichainActionType } from '@popup/multichain/actions/action-type.enum';
export const TitleContainerReducer = (state = { title: '' }, { type, payload }) => {
    switch (type) {
        case MultichainActionType.SET_TITLE_PROPERTIES:
            return payload;
        default:
            return state;
    }
};
